module.exports = __webpack_public_path__ + "static/media/aboutyili.2abff892.fffafe53.png";